"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftDateDto = instanceOfShiftDateDto;
exports.ShiftDateDtoFromJSON = ShiftDateDtoFromJSON;
exports.ShiftDateDtoFromJSONTyped = ShiftDateDtoFromJSONTyped;
exports.ShiftDateDtoToJSON = ShiftDateDtoToJSON;
exports.ShiftDateDtoToJSONTyped = ShiftDateDtoToJSONTyped;
const ShiftTime_1 = require("./ShiftTime");
/**
 * Check if a given object implements the ShiftDateDto interface.
 */
function instanceOfShiftDateDto(value) {
    if (!('shiftTime' in value) || value['shiftTime'] === undefined)
        return false;
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    return true;
}
function ShiftDateDtoFromJSON(json) {
    return ShiftDateDtoFromJSONTyped(json, false);
}
function ShiftDateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftTime': (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'startDate': (new Date(json['startDate'])),
        'customStartTime': json['customStartTime'] == null ? undefined : json['customStartTime'],
        'customEndTime': json['customEndTime'] == null ? undefined : json['customEndTime'],
    };
}
function ShiftDateDtoToJSON(json) {
    return ShiftDateDtoToJSONTyped(json, false);
}
function ShiftDateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'startDate': ((value['startDate']).toISOString().substring(0, 10)),
        'customStartTime': value['customStartTime'],
        'customEndTime': value['customEndTime'],
    };
}
//# sourceMappingURL=ShiftDateDto.js.map